<template>
  <base-container
    v-loading="isLoading"
    class="base-container-fixed login-container"
  >
    <div class="login-main">
      <div class="login-logo">
        <img class="logo-icon" src="/img/logo.png" />
        <span class="logo-title">{{config.title}}</span>
      </div>
      <div class="login-form">
        <el-row>
          <el-col :span="12">
            <img height="400px" width="100%" src="/img/login/banner.png" />
          </el-col>
          <el-col :span="12" style="padding: 20px 20px 0 20px">
            <el-tabs>
              <el-tab-pane label="账号登录">
                <el-form
                  class="margin-v12"
                  ref="form"
                  :model="loginInfo"
                  label-width="0"
                >
                  <el-form-item class="account">
                    <el-input
                      type="text"
                      v-model="loginInfo.username"
                      auto-complete="off"
                      placeholder="账号"
                      v-on:keyup.enter.native="login()"
                    >
                      <template #prefix>
                        <div
                          style="
                            height: 100%;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <img src="/img/login/icon-user.png" />
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item class="checkPass">
                    <el-input
                      type="password"
                      v-model="loginInfo.password"
                      auto-complete="off"
                      placeholder="密码"
                      show-password
                      v-on:keyup.enter.native="login()"
                    >
                      <template #prefix>
                        <div
                          style="
                            height: 100%;
                            display: flex;
                            align-items: center;
                          "
                        >
                          <img src="/img/login/icon-password.png" />
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      style="width: 100%"
                      v-on:click="login()"
                      >立即登录 →</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </div>
    </div>
  </base-container>
</template>

<script>
import { login } from "@/api/home";
import { setToken } from "@/util/auth";
import { mapMutations } from "vuex";
import config from "@/config";
export default {
  data() {
    return {
      isLoading: false,
      loginInfo: {
        username: "",
        password: "",
        isRemeber: true,
      },
      config,
    };
  },
  created() {
    this.delAllTab();
  },
  methods: {
    ...mapMutations(["delAllTab"]),
    login: function () {
      let isRight =
        this.loginInfo.username &&
        this.loginInfo.username.length < 32 &&
        this.loginInfo.password &&
        this.loginInfo.password.length < 32;
      if (isRight) {
        this.isLoading = true;
        login(this.loginInfo)
          .then((res) => {
            const data = res.data.data;
            setToken(data.token);
            var redirect = this.$store.getters.getLoginRedirect;
            if (redirect) {
              this.$router.push(redirect);
            } else {
              this.$router.push("/");
            }
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.$message({
          type: "error",
          message: "用户名和密码必填，且长度都不可以超过32位",
        });
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  margin: 0;
  padding: 0;
  background: #f0f1f3 url("/img/login/login-bg.png") center no-repeat;
  background-size: contain;
  font-size: 14px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-main {
  display: inline-block;
  height: 480px;
  width: 800px;
}
.logo-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  /* background: #2a66f2; */
}
.login-logo {
  height: 80px;
  line-height: 80px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo-title {
  padding: 0 12px;
  font-size: 27px;
  font-weight: bold;
}
.login-form {
  height: 400px;
  border-radius: 6px;
  -moz-box-shadow: 0px 0px 12px #dfe1e8;
  -webkit-box-shadow: 0px 0px 12px #dfe1e8;
  box-shadow: 0px 0px 12px #dfe1e8;
  background-size: 50% 100%;
}
.el-tabs__item {
  color: #8d96aa;
  font-size: 16px;
  padding: 0 30px;
}
.el-tabs__nav {
  display: inline-block;
}

.el-tabs__item {
  color: #8d96aa;
  font-size: 16px;
  padding: 0 30px;
}

.el-tabs__nav-wrap::after {
  height: 0 !important;
}
.el-tabs__nav-scroll {
  text-align: center;
}

.el-tabs__item.is-active {
  color: #2a66f2;
  font-size: 18px;
  font-weight: bold;
}

.el-tabs__active-bar {
  height: 4px !important;
  background: #2a66f2;
  border-radius: 10px;
}

.el-tabs__item:hover {
  color: #2a66f2;
}

.el-tabs__content {
  padding: 20px 0;
}

.el-form .el-form-item__content:before {
  content: " ";
  display: block !important;
  width: 36px;
  height: 38px;
  position: absolute;
  z-index: 2;
  left: 1px;
  top: 1px;
  border-radius: 4px 0 0 4px;
}

.el-form .account .el-form-item__content:before {
  border-right: solid 1px #d5dadf;
  background: #f6f9fc url("/img/login/icon-account.png") 11px no-repeat;
}

.el-form .checkPass .el-form-item__content:before {
  border-right: solid 1px #d5dadf;
  background: #f6f9fc url("/img/login/icon-pw.png") 11px no-repeat;
}
.el-input >>> .el-input__inner {
  padding-left: 40px !important;
}
.el-button {
  background: #2a66f2;
  border: none;
}
.el-button:hover {
  background: #2158d7;
}
</style>